module.exports = __webpack_public_path__ + "img/PSS-bg.0bc35548.png";